module.exports = __webpack_public_path__ + "static/media/capacityplanner.52ffecb1.svg";